import { useContext } from 'react';
import { ShopConfigContext } from '../components/ConfigProvider';
import throwErrorInDev from '../helpers/throwErrorInDev';
export function useShopConfig() {
    const config = useContext(ShopConfigContext);
    throwErrorInDev(!config, 'Could not find ShopConfigContext. Is your shop.config.js valid?');
    return config;
}
//# sourceMappingURL=useShopConfig.js.map